/* eslint-disable */
import createIcon from '../createIcon';

const IconFilter = createIcon({
  name: 'icon-filter',
  content: '<title>ic_筛选</title><defs><rect id="icon-filter-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-611.000000, -5607.000000)"><g transform="translate(498.000000, 4920.000000)"><g transform="translate(111.000000, 687.000000)"><g transform="translate(2.000000, 0.000000)"><mask id="icon-filter-b" fill="currentColor"><use xlink:href="#icon-filter-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-filter-a"/><path d="M2.22684384,1 L7,6.36980068 L7,12.5 L9,14 L9,6.36980068 L13.7731562,1 L2.22684384,1 Z M6,6.75 L0,0 L16,0 L10,6.75 L10,16 L6,13 L6,6.75 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-filter-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconFilter;
